// extracted by mini-css-extract-plugin
export var highlightFade = "_3b-4";
export var highlighted = "_3b-3";
export var table = "_3b-1";
export var tableContainer = "_3b-0";
export var totalsRow = "_3b-2";